'use client';

import { NAVIGATION_CONFIG } from '@/shared/constants/landing/landing-navigation.constants';
import { Text } from '@/shared/ui/core';
import { Sidebar, SidebarItem } from '@/shared/ui/layout';
import styles from './landing-navigation.module.scss';


type ComponentProps = {
    onClick?: () => void;
}


export const LandingNavigation = ({ onClick = () => {} }: ComponentProps) => {
    return (
        <Sidebar className={ styles.root }>
            {
                NAVIGATION_CONFIG.map(({ options }) => {
                    return options.map(({ href, label }) => (
                        <SidebarItem
                            key={ href }
                            className={ styles.item }
                            href={ href }
                            icon={ null }
                            title={ label }
                            onClick={ onClick }
                            label={
                                <Text
                                    tone='primary'
                                    weight='medium'
                                    className={ styles.label }
                                    dangerouslySetInnerHTML={ { __html: label } }
                                />
                            }
                        />
                    ));
                })
            }
        </Sidebar>
    );
};
